<h3>Impressum</h3>

<h4>Angaben gemäß § 5 TMG:</h4>
<p>
Sina Jung, i.V. Matthias Jung (Einzelunternehmer)<br>
Schloßstr. 17<br>
86732 Oettingen in Bayern
</p>

<h4>Kontakt:</h4>
<p>
Telefon: 09082 2910<br>
Fax: 09082 4148<br>
E-Mail: info@darwins-reisen.de<br>
</p>

<h4>Umsatzsteuer:</h4>
<p>
Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br/>
DE328168641
</p>

<h3>Widerspruch Werbe-Mails</h3>
<p>Der Nutzung von im Rahmen der Impressumspflicht
veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich
ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa
durch Spam-E-Mails, vor.
</p>
